import React, { useContext } from "react";
import _ from "lodash";
import { Container,  Row, Col } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import AppBar from "../components/headerNav/HeaderNav";
import { ToolbarContextProvider } from "../context/ToolbarContext";
import DashboardToolBoxWrapper from "../components/toolbox/DashboardToolBoxWrapper";
import Header from "../components/header/Header";
import { SummaryContextProvider } from "../context/SummaryContext";
import SummaryHeader from "../components/job-summary/SummaryHeader";
import HistorySummary from "../components/job-summary/HistorySummary";
import SourceSummary from "../components/job-summary/SourceSummary";
import DeliverySummary from "../components/job-summary/DeliverySummary";
import ProcessorSummary from "../components/job-summary/ProcessorSummary";
import { UserContext } from "../context/UserContext";
import "../styles/summary.scss";
import Footer from "../components/footer/Footer";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const JobSummary = () => {
  const { userRole,isUserLoading } = useContext(UserContext);

  return _.isEmpty(userRole) ? null : (
    <SummaryContextProvider>
      <Container
        fluid
        className="summaryContainer">
        <ToolbarContextProvider>
          <Grid container>
            <AppBar />
            {!isUserLoading && <>
              <Grid item xs={10} className="m-0 p-0">
                <Header headingText="Summary" />
              </Grid>
              <Grid item xs={2} className="pt-4 summaryDashboardToolboxGrid">
                <DashboardToolBoxWrapper />
              </Grid>
              <Grid
                item
                xs={12}>
                  <Row className="mx-0 mt-0 mb-4 p-0"
                       id={"Summary_header_view"}>
                  <SummaryHeader />
                </Row>
                <Row id={"Summary_detail_view"}>
                  <Col
                    xs={6}
                    className="jobSummaryColumn"
                    id={"summary_column_left"}>
                    <SourceSummary />
                    <ProcessorSummary />
                    <DeliverySummary />
                  </Col>
                  <Col
                    xs={6}
                    className="jobSummaryColumn"
                    id={"summary_column_right"}>
                    <HistorySummary />
                  </Col>
                </Row>
              </Grid>
            </>}
          </Grid>
        </ToolbarContextProvider>
      </Container>
      <Footer />
      <CookieConsentBanner />
    </SummaryContextProvider>
  );
};
export default JobSummary;
